export const getThemeHeaderBg = (theme, currentTheme) => {
    return currentTheme === 'light'
      ? theme?.background?.headerLight
      : theme?.background?.headerDark;
  };
  
  export const getThemePrimaryColor = (theme) => {
    return theme?.primary?.main;
  };
  
  export const getThemeTextColor = (theme, currentTheme) => {
    return currentTheme === 'light'
      ? theme?.text?.light
      : theme?.text?.dark;
  };
  
  export const getThemeSecondaryColor = (theme) => {
    return theme?.secondary?.main;
  };
  
  export const getThemeBorderColor = (theme, currentTheme) => {
    return currentTheme === 'light'
      ? theme?.border?.light
      : theme?.border?.dark;
  };
  
  export const getThemeHoverBgColor = (theme, currentTheme) => {
    return currentTheme === 'light'
      ? theme?.secondary?.leftLight
      : theme?.secondary?.leftDark;
  };

  export const getThemeBlackWhiteColor = (theme, currentTheme) => {
    return currentTheme === 'light'
    ? theme?.NORMAL_COLOR_WHITE
    : theme?.NORMAL_COLOR_BLACK;
  };

  export const getStudyIconBg = (theme, currentTheme) => {
    return currentTheme === 'light' ? theme?.icon_bg?.study_light : theme?.icon_bg?.study_dark;
  }

  export const getPracticeTestIconBg = (theme, currentTheme) => {
    return currentTheme === 'light' ? theme?.icon_bg?.practice_light : theme?.icon_bg?.practice_dark;
  }

  export const getFlashCardsIconBg = (theme, currentTheme) => {
    return currentTheme === 'light' ? theme?.icon_bg?.flashcard_light : theme?.icon_bg?.flashcard_dark;
  }
  
  export const getCustomTestIconBg = (theme, currentTheme) => {
    return currentTheme === 'light' ? theme?.icon_bg?.custom_light : theme?.icon_bg?.custom_dark;
  }

  export const getColorRed = (theme, currentTheme) => {
    // First try to get the light/dark variant
    const colorFromVariant = theme?.color.red.main;
    
    // If variant not found, fallback to the base COLOR_RED
    return colorFromVariant || theme?.COLOR_RED || '#ff0000';
  }

  export const getColorGreen = (theme, currentTheme) => {
    return theme?.color.green.main;
  }
  export const getColorYellow = (theme, currentTheme) => {
    return theme?.color.yellow.main;
  }
  
  export const getBookMarkColor = (currentTheme,isBookMarked) => {
    let color = '';
    if(isBookMarked){
      color = currentTheme === 'light' ? "#FFD700" : "#FFD700";
    }else{
      color = currentTheme === 'light' ? "#D3D3D3" : "#707070"
    }
    return color;
  }
